module.exports = __webpack_public_path__ + "img/react-js.1394d581.png";